module.exports = __webpack_public_path__ + "html/double-circle-progress_064d21911ba1071c40db0bad55e54c2c.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/landing-template/components/double-circle-progress.html
// module id = fVSO
// module chunks = 98